export default {
  model: {
    'allotTrade': '申购',
    'redeemTrade': '赎回',
    'achievementPayTrade': '业绩报酬',
    'cashDividendTrade': '现金分红',
    'dividendReinvestmentTrade': '分红再投',
    'allotTradeApplyRecord': '申购',
    'redeemTradeApplyRecord': '赎回',
    'personalAccount': '个人客户',
    'companyAccount': '企业客户',
    'productAccount': '产品客户',
    'agentAccount': '代理人客户',
    'role': '角色',
    'activeStorage/attachment': 'Attachment',
    'application': '应用管理',
    'adminUsersRole': '管理员',
    'adminUser': '管理员',
    'banner': '轮播图',
    'profile': 'Profile',
    'feeRate': '费率结构',
    'management': '管理方式',
    'tradeRule': '交易规则',
    'revenueDatum': '收益数据',
    'fundValue': '基金净值',
    'fund': '基金产品',
    'accountFund': 'Account fund',
    'account': '客户',
    'user': '用户',
    'activeStorage/blob': '资源',
    'actsAsTaggableOn/tag': '标签',
    'page': '静态页面',
    'presetPage': '静态页面',
    'staticPage': '静态页面',
    'customPage': '自定义页面',
    'hotWord': '搜索热词',
    'announcement': '公告',
    'monthlyReport': '管理人月报',
    'custodianMonthlyReport': '托管人月报',
    'trade': '交易记录',
    'videoRecord': '视频双录',
    'tradeApplyRecord': '交易申请',
    'riskAssessment': '风险测评',
    'riskAssessmentOption': 'Risk assessment option',
    'riskAssessmentQuestion': 'Risk assessment question',
    'riskAssessmentResult': '风险测评结果',
    'riskAssessmentAnswer': 'Risk assessment answer',
    'operationRecord': '操作日志',
  },
  'allotTrade': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: '净值',
    accountId: '客户',
    fundId: '基金',
    confirmDate: '确认日期',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    parentId: '关联申购记录',
    name: '名称',
    confirmFile: '确认文件',
    account: '客户',
    fund: '基金',
  },
  'redeemTrade': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: '净值',
    accountId: '客户',
    fundId: '基金',
    confirmDate: '确认日期',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    parentId: '关联申购记录',
    name: '名称',
    confirmFile: '确认文件',
    account: '客户',
    fund: '基金',
  },
  'achievementPayTrade': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: '净值',
    accountId: '客户',
    fundId: '基金',
    confirmDate: '确认日期',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    parentId: '关联申购记录',
    name: '名称',
    confirmFile: '确认文件',
    account: '客户',
    fund: '基金',
  },
  'cashDividendTrade': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: '净值',
    accountId: '客户',
    fundId: '基金',
    confirmDate: '确认日期',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    parentId: '关联申购记录',
    name: '名称',
    confirmFile: '确认文件',
    account: '客户',
    fund: '基金',
  },
  'dividendReinvestmentTrade': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: '净值',
    accountId: '客户',
    fundId: '基金',
    confirmDate: '确认日期',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    parentId: '关联申购记录',
    name: '名称',
    confirmFile: '确认文件',
    account: '客户',
    fund: '基金',
  },
  'allotTradeApplyRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: 'Value',
    accountId: 'Account',
    applicantId: 'Applicant',
    fundId: 'Fund',
    state: '状态',
    states: {
      pending: '待审核',
      approved: '已确认',
      rejected: '已作废',
    },
    rejectReason: '作废原因',
    fund: '基金产品',
    account: '交易账户',
    applicant: '申请账户',
    confirmFile: '申请书',
  },
  'redeemTradeApplyRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: 'Value',
    accountId: 'Account',
    applicantId: 'Applicant',
    fundId: 'Fund',
    state: '状态',
    states: {
      pending: '待审核',
      approved: '已确认',
      rejected: '已作废',
    },
    rejectReason: '作废原因',
    fund: '基金产品',
    account: '交易账户',
    applicant: '申请账户',
    confirmFile: '申请书',
  },
  'personalAccount': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    city: '城市',
    email: '邮箱',
    name: '姓名',
    number: '证件号',
    phone: '手机号码',
    referrer: '推荐人',
    remark: '备注',
    type: '类型',
    kind: '所属',
    kinds: {
      internal: '内部产品',
      external: '外部产品',
    },
    riskAssessmentLevel: '风险测评',
    riskAssessmentLevels: {
      C1: '保守型',
      C2: '稳健型',
      C3: '平衡型',
      C4: '成长型',
      C5: '积极型',
    },
    status: '审核状态',
    statuses: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    userId: '用户',
    isStaff: '员工',
    certificateEndDate: '证件有效期',
    agentTargetId: '代理对象',
    tradeAccountId: 'Trade account',
    rejectReason: '拒绝原因',
    accountStatus: '客户状态',
    accountStatuses: {
      visitor: '游客',
      holder: '续存客户',
      history_holder: '历史客户',
    },
    loginActivitiesCount: '近期登录次数',
    user: '用户',
    agentTarget: '代理对象',
    tradeAccountAccountFunds: 'Trade account account funds',
  },
  'companyAccount': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    city: '城市',
    email: '邮箱',
    name: '名称',
    number: '证件号',
    phone: '手机号码',
    referrer: '推荐人',
    remark: '备注',
    type: '类型',
    kind: '所属',
    kinds: {
      internal: '内部产品',
      external: '外部产品',
    },
    riskAssessmentLevel: '风险测评',
    riskAssessmentLevels: {
      C1: '保守型',
      C2: '稳健型',
      C3: '平衡型',
      C4: '成长型',
      C5: '积极型',
    },
    status: '审核状态',
    statuses: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    userId: '用户',
    isStaff: '员工',
    certificateEndDate: '证件有效期',
    agentTargetId: '代理对象',
    tradeAccountId: 'Trade account',
    rejectReason: '拒绝原因',
    accountStatus: '客户状态',
    accountStatuses: {
      visitor: '游客',
      holder: '续存客户',
      history_holder: '历史客户',
    },
    loginActivitiesCount: '近期登录次数',
    user: '用户',
    agentTarget: '代理对象',
    tradeAccountAccountFunds: 'Trade account account funds',
  },
  'productAccount': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    city: '城市',
    email: '邮箱',
    name: '名称',
    number: '证件号',
    phone: '手机号码',
    referrer: '推荐人',
    remark: '备注',
    type: '类型',
    kind: '所属',
    kinds: {
      internal: '内部产品',
      external: '外部产品',
    },
    riskAssessmentLevel: '风险测评',
    riskAssessmentLevels: {
      C1: '保守型',
      C2: '稳健型',
      C3: '平衡型',
      C4: '成长型',
      C5: '积极型',
    },
    status: '审核状态',
    statuses: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    userId: '用户',
    isStaff: '员工',
    certificateEndDate: '证件有效期',
    agentTargetId: '代理对象',
    tradeAccountId: 'Trade account',
    rejectReason: '拒绝原因',
    accountStatus: '客户状态',
    accountStatuses: {
      visitor: '游客',
      holder: '续存客户',
      history_holder: '历史客户',
    },
    loginActivitiesCount: '近期登录次数',
    user: '用户',
    agentTarget: '代理对象',
    tradeAccountAccountFunds: 'Trade account account funds',
  },
  'agentAccount': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    city: '城市',
    email: '邮箱',
    name: '姓名',
    number: '证件号',
    phone: '手机号码',
    referrer: '推荐人',
    remark: '备注',
    type: '类型',
    kind: '所属',
    kinds: {
      internal: '内部产品',
      external: '外部产品',
    },
    riskAssessmentLevel: '风险测评',
    riskAssessmentLevels: {
      C1: '保守型',
      C2: '稳健型',
      C3: '平衡型',
      C4: '成长型',
      C5: '积极型',
    },
    status: '审核状态',
    statuses: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    userId: '用户',
    isStaff: '员工',
    certificateEndDate: '证件有效期',
    agentTargetId: '代理对象',
    tradeAccountId: 'Trade account',
    rejectReason: '拒绝原因',
    accountStatus: '客户状态',
    accountStatuses: {
      visitor: '游客',
      holder: '续存客户',
      history_holder: '历史客户',
    },
    loginActivitiesCount: '近期登录次数',
    user: '用户',
    agentTarget: '代理对象',
    tradeAccountAccountFunds: 'Trade account account funds',
  },
  'role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      super: 'Super',
      application: '应用管理',
      custom: 'Custom',
    },
    customPermissions: '自定义权限',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'application': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    wechatApplicationId: 'Wechat application',
    customerServicePhone: '客服电话',
    customerServiceWechat: '客服微信',
    wechatAuditUserId: '微信审核用户ID',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    creator: 'Creator',
    posterImage: '海报图片',
    riskWarning: '风险提示',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    isBlock: '已冻结',
    role: '角色',
    application: '应用管理',
    adminUser: '管理员',
    adminUserAttributes: 'Admin user attributes',
  },
  'adminUser': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    email: '邮箱',
    name: '姓名',
    adminUsersRolesAttributes: 'Admin users roles attributes',
  },
  'banner': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      event: '事件',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  'profile': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    email: '邮箱',
    phone: '手机号码',
    gender: '性别',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'feeRate': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    allotFee: '申购费',
    redeemFee: '赎回费',
    managementFee: '管理费',
    custodianFee: '托管费',
    outsourcingServiceFee: '外包服务费',
    achievementPay: '业绩报酬',
    accrualTime: '计提时点',
  },
  'management': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    openDay: '开放日',
    allotDay: '申购日',
    redeemDay: '赎回日',
    transactionProcess: '交易流程',
    allotThreshold: '申购门槛',
    redeemLimit: '赎回限制',
    raiseAccount: '募集账户',
    investmentScope: '投资范围',
  },
  'tradeRule': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    hint: '提示',
    name: '名称',
    content: '具体内容',
  },
  'revenueDatum': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    totalShare: '总份额',
    totalCapital: '总资产',
    latestEarnings: 'Latest earnings',
    annualizedRateOfReturn: 'Annualized rate of return',
    netInvestment: '净投入',
    accumulativeReturn: '投资收益',
    accumulativeRateOfReturn: 'Accumulative rate of return',
    incomeOfThisYear: 'Income of this year',
  },
  'fundValue': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    value: '单位净值',
    fundId: '基金产品',
    date: '日期',
    accumulativeValue: '累计净值',
    fund: '基金产品',
  },
  'fund': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    closedPeriod: '封闭期',
    code: '基金业协会编码',
    custodian: '托管机构',
    earlyWarning: '预警线/止损线',
    name: '产品名称',
    shortName: '产品简称',
    totalScale: '总规模',
    riskLevel: '风险等级',
    riskLevels: {
      R1: 'R1',
      R2: 'R2',
      R3: 'R3',
      R4: 'R4',
      R5: 'R5',
    },
    visibility: '权限',
    visibilities: {
      holder: '持有人可见',
      holder_and_visitor: '持有人和游客可见',
      invisible: '不可见',
    },
    setupDate: '成立日期',
    isIndex: 'Is index',
    allotTradeRuleId: '申购规则',
    redeemTradeRuleId: '赎回规则',
    feeRate: '费率结构',
    management: '管理方式',
    allotProcess: '申购流程',
    allotTradeRule: '申购规则',
    redeemTradeRule: '赎回规则',
    revenueDatum: '收益数据',
    latestFundValue: 'Latest fund value',
    holdersCount: '持有人数量',
  },
  'accountFund': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    amount: '投资本金',
    share: 'Share',
    accountId: 'Account',
    fundId: 'Fund',
    alreadyVideoRecord: '已双录',
    lastConfirmDate: '最后投资日期',
    fund: '基金产品',
    revenueDatum: '收益数据',
    account: '客户',
  },
  'account': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    city: '城市',
    email: '邮箱',
    name: '名称',
    number: '证件号',
    phone: '手机号码',
    referrer: '推荐人',
    remark: '备注',
    type: '类型',
    kind: '所属',
    kinds: {
      internal: '内部产品',
      external: '外部产品',
    },
    riskAssessmentLevel: '风险测评',
    riskAssessmentLevels: {
      C1: '保守型',
      C2: '稳健型',
      C3: '平衡型',
      C4: '成长型',
      C5: '积极型',
    },
    status: '审核状态',
    statuses: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    userId: '用户',
    isStaff: '员工',
    certificateEndDate: '证件有效期',
    agentTargetId: '代理对象',
    tradeAccountId: 'Trade account',
    rejectReason: '拒绝原因',
    accountStatus: '客户状态',
    accountStatuses: {
      visitor: '游客',
      holder: '续存客户',
      history_holder: '历史客户',
    },
    loginActivitiesCount: '近期登录次数',
    user: '用户',
    agentTarget: '代理对象',
    tradeAccountAccountFunds: 'Trade account account funds',
    personas: '客户画像',
    audioOrVideoRecordingFile: '录音录像',
    bankCardScanFile: '银行卡扫描件',
    fundContract: '基金合同',
    numberScanFile: '证件扫描件',
    proofOfAssets: '资产证明或收入证明',
    qualifiedInvestorCommitmentLetter: '合格投资者承诺书',
    riskAssessmentFile: '风险测评问卷',
    riskDisclosure: '风险揭示书',
    supplementaryAgreementToFundContract: '基金合同之补充协议',
    otherFiles: '其他文件',
    hasVideoRecords: '双录',
  },
  'user': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: '微信昵称',
    isBlock: '已冻结',
    snsAuthorized: 'Sns authorized',
    loginActivitiesCount: '近期登录次数',
    wechatMpOpenid: '微信小程序openid',
    profile: 'Profile',
    avatar: '头像',
    accounts: '关联客户',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: '类型',
    filename: '文件名',
    byteSize: 'Byte size',
    url: '内容',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'page': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    viewsCount: '浏览数',
    publishedAt: '发布时间',
    wxacode: '小程序码',
    content: '内容',
  },
  'presetPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    viewsCount: '浏览数',
    content: '内容',
  },
  'staticPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    status: '状态',
    viewsCount: '浏览数',
    wxacode: '小程序码',
    content: '内容',
  },
  'customPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    publishedAt: '最后发布时间',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  'hotWord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    position: '优先级',
    applicationId: '应用ID',
    application: '应用管理',
  },
  'announcement': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    authorType: 'Author type',
    title: '标题',
    type: '类型',
    authorId: 'Author',
    fundId: '基金',
    fund: '基金产品',
    publishedAt: '发布于',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
      pdf: 'PDF',
    },
    announcedAt: '公告时间',
    content: '内容',
    markdownContent: 'Markdown内容',
    pdfFile: 'PDF文件',
  },
  'monthlyReport': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    authorType: 'Author type',
    title: '标题',
    type: '类型',
    authorId: 'Author',
    fundId: '基金',
    publishedAt: '发布于',
    fund: '基金产品',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
      pdf: 'PDF',
    },
    announcedAt: '公告时间',
    content: '内容',
    markdownContent: 'Markdown内容',
    pdfFile: 'PDF文件',
  },
  'custodianMonthlyReport': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    authorType: 'Author type',
    title: '标题',
    type: '类型',
    authorId: 'Author',
    fundId: '基金',
    publishedAt: '发布于',
    fund: '基金产品',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
      pdf: 'PDF',
    },
    announcedAt: '公告时间',
    content: '内容',
    markdownContent: 'Markdown内容',
    pdfFile: 'PDF文件',
  },
  'trade': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    types: {
      'AllotTrade': '申购',
      'RedeemTrade': '赎回',
      'AchievementPayTrade': '业绩报酬',
      'CashDividendTrade': '现金分红',
      'DividendReinvestmentTrade': '分红再投',
    },
    amount: '金额',
    share: '份额',
    value: '净值',
    accountId: '客户',
    fundId: '基金',
    confirmDate: '确认日期',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    parentId: '关联申购记录',
    name: '名称',
    confirmFile: '确认文件',
    account: '客户',
    fund: '基金',
    parent: '关联申购记录',
  },
  'videoRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    investmentPrincipal: '投资本金',
    accountId: '账户',
    fundId: '基金产品',
    status: '状态',
    statuses: {
      pending: '未完成',
      auditing: '审核中',
      finished: '已完成',
      rejected: '已拒绝',
    },
    lastInvestmentDate: '最后投资日期',
    rejectReason: '拒绝原因',
    account: '客户',
    fund: '基金产品',
    video: '双录视频',
  },
  'tradeApplyRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: '类型',
    amount: '金额',
    share: '份额',
    value: 'Value',
    accountId: 'Account',
    applicantId: 'Applicant',
    fundId: 'Fund',
    state: '状态',
    states: {
      pending: '待审核',
      approved: '已确认',
      rejected: '已作废',
    },
    rejectReason: '作废原因',
    fund: '基金产品',
    account: '交易账户',
    applicant: '申请账户',
    confirmFile: '申请书',
  },
  'riskAssessment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      personal: '自然人',
      company: '产品及企业',
    },
    state: '状态',
    states: {
      draft: '草稿中',
      published: '发布',
      closed: '已关闭',
    },
    riskAssessmentQuestions: '问题',
  },
  'riskAssessmentOption': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    content: '内容',
    score: '得分',
    position: '优先级',
  },
  'riskAssessmentQuestion': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    content: '内容',
    position: '优先级',
    kind: '类型',
    kinds: {
      single_choice: '单选',
      multiple_choice: '多选',
    },
    riskAssessmentOptions: '选项',
  },
  'riskAssessmentResult': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    accountId: 'Account',
    riskAssessmentId: 'Risk assessment',
    score: '分数',
    riskAssessmentLevel: '风险等级',
    riskAssessmentLevels: {
      C1: '保守型',
      C2: '稳健型',
      C3: '平衡型',
      C4: '成长型',
      C5: '积极型',
    },
    account: '客户',
    riskAssessment: '风险测评',
    file: 'PDF文件',
    riskAssessmentAnswers: '回答',
  },
  'riskAssessmentAnswer': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    riskAssessmentOptionIds: 'Risk assessment option ids',
    riskAssessmentQuestion: 'Risk assessment question',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    content: '内容',
    contentEn: 'Content en',
    adminUser: '管理员',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
}
